import * as React from "react";
import { Header } from "src/components/Header";
import { Page } from "src/components/Page";
import { trpc } from "src/trpc";
import { usePlaidLink } from "react-plaid-link";
import { LinkIcon } from "lucide-react";

export function LinkAccount() {
  const { data: linkToken } = trpc.plaid.getLinkToken.useQuery();
  const { mutateAsync: exchangePublicToken } = trpc.plaid.exchangePublicToken.useMutation();
  const plaid = usePlaidLink({
    token: linkToken ?? null,
    onSuccess: async (public_token) => {
      await exchangePublicToken({ public_token });
    },
  });
  return (
    <Page>
      <Header title="Link Account">
        <Header.Button icon={LinkIcon} onClick={() => plaid.open()}>
          Link Account
        </Header.Button>
      </Header>
    </Page>
  );
}
